module.exports = __webpack_public_path__ + "static/media/22.22fd2531.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/22.png
// module id = 36
// module chunks = 0